import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=6d4e77ba&scoped=true&"
import script from "./fields.vue?vue&type=script&lang=js&"
export * from "./fields.vue?vue&type=script&lang=js&"
import style0 from "./fields.vue?vue&type=style&index=0&id=6d4e77ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e77ba",
  null
  
)

export default component.exports